import { isC3Experience } from "../../../shared/util/C3Utils";
define((require) => {
    "use strict";

    const ImageModel                = require("ui/assets/image/ImageModel");
    const RestApi                   = require("shared/services/RestApi");
    const UrlUtil                   = require("shared/util/UrlUtil");
    const AbstractFileStorage       = require("services/files/AbstractFileStorage");
    const Configuration             = require("shared/services/Configuration");

    // Supported image extensions and (way to large) image sizes, matching the constraints at the backend...
    const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif"];

    /**
     * The file storage service.
     *
     * @class ImageFileStorage
     */
    const ImageFileStorage = AbstractFileStorage.extend({

        _modelInfo(file) {
            const expHasC3prefix = isC3Experience();
            let url = UrlUtil.appendParamObject(RestApi.pathToCollection(RestApi.Collections.IMAGES), { filename: file.name });
            let c3ApiUpload = false;
            if (expHasC3prefix) {
                url = UrlUtil.appendParamObject(`${Configuration.c3ApibaseUrl}/v1/images?folderPath=/`, { filename: file.name })
                c3ApiUpload = true
            }
            return {
                modelClass: ImageModel,
                url,
                supportedTypes: IMAGE_EXTENSIONS,
                errorMessages: {
                    // HttpStatusCodes.CONFLICT (409) has special meaning for image upload.
                    CONFLICT: "it is already in the process of being uploaded."
                },
                c3ApiUpload // @boolean , indicate whether will upload to C3 or Legacy
            };
        }
    });

    return ImageFileStorage;
});



// WEBPACK FOOTER //
// ./src/editor/services/files/ImageFileStorage.js